import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
import { typeOf } from "../../type/typeOf";
/**
 * Immutably drops the first or last specified number of items of an array
 *
 * @since v2.27.0
 * @category Array
 * @template {T} - The type of the array
 * @param {T[]} array - The original array
 * @param {number} count - If positive, the number of items to drop from the start of the array If negative, the number of items to drop from the end of the array
 * @returns {T[]} The first/last items of the array
 * @example
 * const array = [1, 2, 3];
 *
 * drop(array, 2)   //=> [3]
 * drop(array, -2)  //=> [1]
 * drop(array, 25)  //=> []
 * @docgen_example
 * drop([1, 2, 3], 2);
 */
export var drop = function (array, count) {
    return typeOf(array) === 'array' &&
        isNotNilOrEmpty(array) && ((count < 0 && array.length > Math.abs(count) && array.slice(0, array.length + count)) ||
        (count > 0 && array.slice(count, array.length)) ||
        (count === 0 && array)) || [];
};
